import { IUserRepository } from "@/core/repositories/user";

export class GetUserBrandsUseCase {
  constructor(private readonly userRepository: IUserRepository) {}
  async execute() {
    return this.userRepository.getUserBrands();
  }
}
